var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "split-pane",
        [
          _vm.defer(2)
            ? _c("component-tree", {
                attrs: { slot: "left", instances: _vm.instances },
                slot: "left"
              })
            : _vm._e(),
          _vm.defer(3)
            ? _c("component-inspector", {
                attrs: {
                  slot: "right",
                  target: _vm.inspectedInstance,
                  loading: _vm.loading
                },
                slot: "right"
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }